import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { env } from "@environments/environment";
import { map } from "rxjs/operators";
import { PageModel } from "@app/models/page.model";
import { Supply } from "@app/models/supply.model";
import { GoodAdapter } from "@app/adapters/good.adapter";
import { Good } from "@app/models/good.model";

@Injectable({ providedIn: "root" })
export class GoodApiService {

  constructor(private readonly adapter: GoodAdapter, private readonly http: HttpClient) {
  }

  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1`;

  getGood(goodId: string): Observable<Good> {
    return this.http.get<Good>(`${this.baseUrl}/goods?goodId=${goodId}`).pipe(map(data => this.adapter.adapt(data)));
  }

  getGoodsAll(params: HttpParams): Observable<PageModel<Good>> {
    return this.http.get<PageModel<Good>>(`${this.baseUrl}/goods/all`, { params }).pipe(map(data => new PageModel<Supply>({
      totalPages: data.totalPages, totalElements: data.totalElements, content: this.adapter.adaptArray(data.content),
    })));
  }

}
